'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProductBasedOfferIds;

var _ProductBasedOfferIds2 = require('self-service-api/constants/ProductBasedOfferIds');

var ProductBasedOfferIds = _interopRequireWildcard(_ProductBasedOfferIds2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_ProductBasedOfferIds = {}, _defineProperty(_ProductBasedOfferIds, ProductBasedOfferIds.FREE_CRM_SALES_STARTER_KIT, {
  trackingName: 'Starter Kit - Free',
  active: false
}), _defineProperty(_ProductBasedOfferIds, ProductBasedOfferIds.FREE_SERVICE_PROFESSIONAL_ONBOARDING, {
  trackingName: 'Service Professional Onboarding - Free',
  active: false
}), _ProductBasedOfferIds);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/ImmutableProductBasedOfferIdMap.js
// module id = 350
// module chunks = 3 4 5